<template>
	<div>
		<StateBar class="w-25p" />
        <section class="con-1334 box-white mt-30px mb-30px" v-if="getLoadedAddress">
            <h2 class="fs-title text-center">Betöltött cím:</h2>
            <h3 class="fs-title text-center">{{ getLoadedAddress }}</h3>
        </section>
		<h2 class="fs-title text-center">Ingatlan adatai</h2>
		<ValidationObserver ref="form" v-slot="{ invalid }">
			<form @submit.prevent="beforeSubmit">
				<CalcElements :elements="elements" />
				<CalcElements v-if="!isLoggedIn" :elements="plusElements" />
			</form>
			<NavButtons :prevLink="prevLink" :nextLink="nextLink" @next="beforeSubmit" @prev="onPrev" />
		</ValidationObserver>
	</div>
</template>

<script>
import PropertyDetails from '@json/PropertyDetails.json';
import CalcElements from '@/components/CalcElements.vue';
import NavButtons from '@/components/NavButtons.vue';
import validation from '@/mixins/validation';
import Popup from '@/components/Popup.vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
	mixins: [validation],
	async mounted() {
		if (this.getOutbuildingTypes.length === 0) {
			await this.fetchOutbuildingTypes();
		}

		if (this.getOutbuildingLocations.length === 0) {
			await this.fetchOutbuildingLocations();
		}

		if (this.getRealEstate.id !== null) {
			this.setStateData({ prop: 'insuranceValueIsRandom', value: this.getRealEstate.insurance_value === null });
			this.toggleInsuranceValue();
			this.$refs.form.validate();
		}
	},
	data() {
		return {
			elements: PropertyDetails,
			plusElements: {
				groupElements4: {
					groupClass: 'elementsWrapper',
					elements: {
                        label6: {
                            label: 'Kérjük, adja meg kapcsolattartási adatait:',
                            type: 'label',
                            className: 'd-intable w-100 float-left mb-15px mt-30px',
                            tooltip: false,
                        },
                        last_name: {
                            inputGroup: 'calculation',
                            type: 'text',
                            rules: 'required',
                            inputClass: 'w-50 mobile-width-full',
                            wrapperClass: '',
                            className: 'mw-500px ml-auto',
                            label: `Vezetéknév`,
                            noInitialValidation: true,
                        },
                        first_name: {
                            inputGroup: 'calculation',
                            type: 'text',
                            rules: 'required',
                            inputClass: 'w-50 mobile-width-full',
                            wrapperClass: '',
                            className: 'mw-500px ml-auto',
                            label: `Keresztnév`,
                            noInitialValidation: true,
                        },
						label2: {
							label: '',
							type: 'label',
							className: 'd-intable w-50 float-left mb-15px mt-30px',
							tooltip: false,
						},
						label3: {
							label: '',
							type: 'label',
							className: 'd-intable w-50 float-left mb-15px mt-30px',
							tooltip: false,
						},
						email: {
							inputGroup: 'calculation',
							type: 'text',
							rules: 'required|email',
							inputClass: 'w-50 mobile-width-full',
							wrapperClass: '',
							className: 'mw-500px ml-auto',
							label: `E-mail cím`,
							inputmode: 'email',
                            noInitialValidation: true,
						},
						phone: {
							inputGroup: 'calculation',
							type: 'phone',
							inputClass: 'w-50 mobile-width-full',
							wrapperClass: '',
							className: 'mw-500px ml-auto',
							label: `Telefonszám`,
							inputmode: 'phone',
                            isMobile: true,
                            rules: {required:true},
                            noInitialValidation: true,
						},
                        checkbox: {
                            inputGroup: 'calculation',
                            type: "checkbox",
                            label: "Elolvastam és elfogadom az <a href=\"/adatvedelem\" target=\"_blank\">Adatkezelésről</a> szóló tájékoztatóban foglaltakat.",
                            wrapperClass: "col-w100-chbox chbox_style-wrapper marketing-checkbox-fix",
                            inputClass: "mt-30px col-w100-chbox chbox_style-wrapper",
                            className: "mw-500px d-table",
                            rules: 'marketing_checkbox',
                            noInitialValidation: true,
                        },
					},
				},
			},
			prevLink: 'home',
		};
	},
	computed: {
		...mapGetters(['getRealEstate', 'getOutbuildings', 'getOutbuildingTypes', 'getOutbuildingLocations','getLoadedAddress','getIsBusinessProcess','getMatchingRealEstateUsers','getHasParcelNumber']),
		...mapGetters('auth', ['isLoggedIn']),
		nextLink() {
			return this.hasMovables ? 'movable' : 'contract-details';
		},
	},
	methods: {
		...mapMutations(['setStateData', 'toggleInsuranceValue', 'setRealEstateData', 'showPopup']),
		...mapActions(['fetchOutbuildingTypes', 'fetchOutbuildingLocations', 'fetchMatchingRealEstateUsers']),
        cleanAddressFields(){
            if(this.getRealEstate.type !== 0) {
                this.setRealEstateData({
                    ...this.getRealEstate,
                    door: null,
                    floor: null,
                    building: null,
                    stairway: null,
                });
            }

            if(this.getHasParcelNumber) {
                this.setRealEstateData({
                    ...this.getRealEstate,
                    house_number: null,
                    house_number_to: null,
                });
            } else {
                this.setRealEstateData({
                    ...this.getRealEstate,
                    parcel_number: null,
                });
            }
        },
        async beforeSubmit() {
            this.cleanAddressFields();
            if (this.getIsBusinessProcess) {
                await this.fetchMatchingRealEstateUsers();
                if(this.getMatchingRealEstateUsers.length > 0) {
                    console.log('showing popup');
                    this.showPopup('MatchingCalculation');
                }
            }
            return this.onSubmit();
        },
	},
	components: {
		CalcElements,
		NavButtons,
		Popup,
	},
};
</script>
